import { Component, OnInit, HostListener, Renderer } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { DOCUMENT } from "@angular/platform-browser";

// APP
import { AppConfig } from '../../app.config';
import { AuthenticationService } from '../../services/authentication.service';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'app-navmenu',
  templateUrl: './navmenu.component.html',
  providers: [AuthenticationService]
})
export class NavmenuComponent implements OnInit {
    loginDetail: any;
    pageError: Array<any> = [];
    isLoginUrl: boolean = false; 
    isLoggedin: boolean = false;
    navIsFixed: boolean = false; 
    pageName: string = ''; 
    _baseAppUrl: string = AppConfig.config.baseAppUrl;
    _rootAppUrl: string = AppConfig.config.rootAppUrl;
    env: string = AppConfig.config.env;
    helpUrl: string = this._rootAppUrl + 'assets/help.html';

    constructor(private authenticationService: AuthenticationService,
        public router: Router,
        private renderer: Renderer, 
        private sharedService: SharedService
        )
    {
        router.events.forEach((event) => {
            if (event instanceof NavigationStart) {
                this.isLoggedin = this.authenticationService.isLoggedIn();
                if (this.sharedService.getData('loggedInUser') != null)
                    this.isLoggedin == true;

                if (event.url.indexOf('/login') >= 0)
                    this.isLoginUrl = true; 
                else 
                    this.isLoginUrl = false;

                if (event.url.indexOf('/home') >= 0)
                    this.pageName = 'home';
                else if (event.url.indexOf('/account') >= 0)
                    this.pageName = 'account';
                else
                    this.pageName = '';
            }            
        });

        this.renderer.listenGlobal('window', 'scroll', (evt) => {           
            this.navIsFixed = (evt.srcElement.body.scrollTop >= 85);
            //console.log(evt.srcElement.body.scrollTop + ' : ' + this.navIsFixed);
            //// Get error and message div if any
            //let err = evt.srcElement.body.getElementsByClassName("alertRed");
            //let msg = evt.srcElement.body.getElementsByClassName("alertGreen");
            //if (err != null) {
            //    console.log(err + ' : ' + $('#pageError') );
            //    //if (this.navIsFixed == true) {
            //    //    err.classList.add('fixedHeaderMessage'); 
            //    //    err.classList.remove('systemMessage');
            //    //} else {
            //    //    err.classList.add('systemMessage'); 
            //    //    err.classList.remove('fixedHeaderMessage'); 
            //    //}
            //}

        });
    }

    //@HostListener('scroll', ['$event'])
    //onScroll(event) {
    //    let scroll = event.scrollTop;
    //    //this.navIsFixed = (scroll >= 130);
    //}

    ngOnInit() {
       
        this.navIsFixed = false;    
        var loggedIn = this.sharedService.getData("loggedInUser");
     
        if (loggedIn != null) {
            this.isLoggedin = true;
        }
        else {
            this.isLoggedin = false; 
        }
    }

  login() {
      window.location.href = AppConfig.config.cpuiLoginUrl;
  }

  logout() {
      this.sharedService.removeData('loggedInUser');
      sessionStorage.clear();
      window.location.href = AppConfig.config.cpuiLogoutUrl;
  }
    
  // NYCID 2.0
  updateProfile() {
      var profileUrlLink = this._rootAppUrl + 'hpdcpui/InitiateUpdateProfile.aspx';      
      window.location.href = profileUrlLink;
  } 

/*
   //NYCID 1.0
  updateProfile() {
      var profileUrlLink = ''; 
      this.authenticationservice.getUpdateProfile()      
          .subscribe(profileUrl => {
              profileUrlLink = profileUrl.d;

              window.location.href = profileUrlLink; 
          });  
  } */
    
  navigateToHome() {
    this.sharedService.navigateHome();
  }

  navigateToAccount() {
    this.sharedService.navigateAccount();
  }

  navigateToHelp() {
      window.location.href = this._baseAppUrl + 'help.html';
  }

}
